import { render, staticRenderFns } from "./case-color-picker.vue?vue&type=template&id=5c40a071&scoped=true&"
import script from "./case-color-picker.vue?vue&type=script&lang=js&"
export * from "./case-color-picker.vue?vue&type=script&lang=js&"
import style0 from "./case-color-picker.vue?vue&type=style&index=0&id=5c40a071&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c40a071",
  null
  
)

export default component.exports